export const changestartDateReducer = (state = '2004-01-01', action) => {
  switch (action.type) {
    case "CHANGE_START_DATE":
      return action.payload.startDateSelected;
    default:
      return state;
  }
};
